export const getWalletPassUrl = `
  query GetWalletPassUrl(
    $input: GetWalletPassUrlInput!
  ) {
    url: getWalletPassUrl(input: $input)
  }
`;
